import { useTranslation } from "react-i18next";
import { string, z } from "zod";

function useCheckEmail() {
  const { t } = useTranslation();
  return z.object({
    email: string()
      .email()
      .min(1, { message: t("CantBeEmpty") }),
  });
}

function setErrorForNewEmail(error, setError, t) {
  if (error == "EmailTaken") {
    setError(
      "email",
      { type: "focus", message: t("EmailTaken") },
      { shouldFocus: true }
    );
    return false;
  }
  return true;
}

export { useCheckEmail,setErrorForNewEmail };
